<template>
  <a-modal
    title="编辑问诊订单管理"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="提交时间"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-date-picker style="width: 100%" placeholder="请选择提交时间" v-decorator="['ctstamp',{rules: [{ required: true, message: '请选择提交时间！' }]}]" @change="onChangectstamp"/>
        </a-form-item>
        <a-form-item
          label="订单编号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入订单编号" v-decorator="['orderId', {rules: [{required: true, message: '请输入订单编号！'}]}]" />
        </a-form-item>
        <a-form-item
          label="订单类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入订单类型" v-decorator="['orderType', {rules: [{required: true, message: '请输入订单类型！'}]}]" />
        </a-form-item>
        <a-form-item
          label="病人ID"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入病人ID" v-decorator="['personId', {rules: [{required: true, message: '请输入病人ID！'}]}]" />
        </a-form-item>
        <a-form-item
          label="姓名"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入姓名" v-decorator="['patientname', {rules: [{required: true, message: '请输入姓名！'}]}]" />
        </a-form-item>
        <a-form-item
          label="性别"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入性别" v-decorator="['sex', {rules: [{required: true, message: '请输入性别！'}]}]" />
        </a-form-item>
        <a-form-item
          label="生日"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-date-picker style="width: 100%" placeholder="请选择生日" v-decorator="['birthday',{rules: [{ required: true, message: '请选择生日！' }]}]" @change="onChangebirthday"/>
        </a-form-item>
        <a-form-item
          label="支付金额"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        </a-form-item>
        <a-form-item
          label="订单状态"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入订单状态" v-decorator="['orderState', {rules: [{required: true, message: '请输入订单状态！'}]}]" />
        </a-form-item>
        <a-form-item
          label="就诊类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入就诊类型" v-decorator="['treatType', {rules: [{required: true, message: '请输入就诊类型！'}]}]" />
        </a-form-item>
        <a-form-item
          label="科室名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入科室名称" v-decorator="['deptname', {rules: [{required: true, message: '请输入科室名称！'}]}]" />
        </a-form-item>
        <a-form-item v-show="false"><a-input v-decorator="['id']" /></a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import moment from 'moment'
  import { inquiryorderEdit } from '@/api/modular/interhospital/inquiryorder/inquiryorderManage'
  export default {
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        ctstampDateString: '',
        birthdayDateString: '',
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this)
      }
    },
    methods: {
      moment,
      // 初始化方法
      edit (record) {
        this.visible = true
        setTimeout(() => {
          this.form.setFieldsValue(
            {
              orderId: record.orderId,
              orderType: record.orderType,
              personId: record.personId,
              patientname: record.patientname,
              sex: record.sex,
              feeall: record.feeall,
              orderState: record.orderState,
              treatType: record.treatType,
              deptname: record.deptname,
              id: record.id }
          )
        }, 100)
        // 时间单独处理
        if (record.ctstamp != null) {
            this.form.getFieldDecorator('ctstamp', { initialValue: moment(record.ctstamp, 'YYYY-MM-DD') })
        }
        this.ctstampDateString = moment(record.ctstamp).format('YYYY-MM-DD')
        // 时间单独处理
        if (record.birthday != null) {
            this.form.getFieldDecorator('birthday', { initialValue: moment(record.birthday, 'YYYY-MM-DD') })
        }
        this.birthdayDateString = moment(record.birthday).format('YYYY-MM-DD')
      },
      handleSubmit () {
        const { form: { validateFields } } = this
        this.confirmLoading = true
        validateFields((errors, values) => {
          if (!errors) {
            for (const key in values) {
              if (typeof (values[key]) === 'object') {
                values[key] = JSON.stringify(values[key])
              }
            }
            values.ctstamp = this.ctstampDateString
            values.birthday = this.birthdayDateString
            inquiryorderEdit(values).then((res) => {
              if (res.success) {
                this.$message.success('编辑成功')
                this.confirmLoading = false
                this.$emit('ok', values)
                this.handleCancel()
              } else {
                this.$message.error('编辑失败')//  + res.message
              }
            }).finally((res) => {
              this.confirmLoading = false
            })
          } else {
            this.confirmLoading = false
          }
        })
      },
      onChangectstamp(date, dateString) {
        this.ctstampDateString = dateString
      },
      onChangebirthday(date, dateString) {
        this.birthdayDateString = dateString
      },
      handleCancel () {
        this.form.resetFields()
        this.visible = false
      }
    }
  }
</script>
